import "./isLoadings.css";

export default function IsLoading() {
  return (
    <section className="sectionLoading">
      <div className="loading-spinner"></div>
    </section>
  );
}
